import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      isUserLogoutMenuOpen: false
    }
  },
  methods: {
    ...mapActions([
      'clearStorage'
    ]),
    logout () {
      this.clearStorage()
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount'
    ])
  }
}
